module.exports = __webpack_public_path__ + "images/star-outline5b7511f04d88f758600157a271d27eed.svg";